import * as React from 'react';

type SuccessCheckIconProps = {
  size?: number | string;
  title?: string;
  className?: string;
  style?: React.CSSProperties;
  color?: string;
};

const SuccessCheckIcon = ({size = 18, style, className, title}: SuccessCheckIconProps) => {
  const s = typeof size === 'number' ? `${size}px` : size;
  
  return (
    <span
      role='img'
      aria-label={title}
      title={title}
      className={className}
      style={{
        display: 'inline-block',
        width: s,
        height: s,
        lineHeight: 0,
        ...style,
      }}
    >
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width={size}
        height={size}
        viewBox='0 0 24 24'
        fill='none'
      >
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M12 22.0007C17.5228 22.0007 22 17.5236 22 12.0007C22 6.47788 17.5228 2.00073 12 2.00073C6.47715 2.00073 2 6.47788 2 12.0007C2 17.5236 6.47715 22.0007 12 22.0007ZM17.707 9.70781C18.0976 9.31728 18.0976 8.68412 17.707 8.29359C17.3165 7.90307 16.6833 7.90307 16.2928 8.29359L10.4782 14.1082L7.70704 11.3371C7.31652 10.9465 6.68335 10.9465 6.29283 11.3371C5.9023 11.7276 5.9023 12.3608 6.29283 12.7513L10.4782 16.9367L17.707 9.70781Z'
          fill='white'
        />
      </svg>
    </span>
  );
}
export default SuccessCheckIcon;
